module.exports = __webpack_public_path__ + "img/public/AdminIcons/logoutIcon.svg?d6c69f13";